// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"34d7aaaa","299":"52640384","341":"6d64684d","453":"fc7dff19","998":"a01d8d2d"}[chunkId] + ".chunk.js";
};